import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { LOADER_ON, LOADER_OFF, contract } from '../../actions/constant';
import contractService from '../../../services/apiServices/contract-services/contractCount';

const { GET_CONTRACT_COUNT_REQUEST, GET_CONTRACT_COUNT_SUCCESS, GET_CONTRACT_COUNT_FAILURE } =
  contract;

function* getContractCount(): SagaReturnType<any> {
  try {
    yield put({ type: LOADER_ON });
    const response = yield call(contractService.getContractCount);

    if (response?.status === 200) {
      yield put({
        type: GET_CONTRACT_COUNT_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_CONTRACT_COUNT_FAILURE, payload: error });
  } finally {
    yield put({ type: LOADER_OFF });
  }
}

function* getContractCountSaga() {
  yield takeEvery(GET_CONTRACT_COUNT_REQUEST, getContractCount);
}

export default getContractCountSaga;
